import React, { useState, useEffect } from "react";
import {
  MdClose,
  MdHeadphones,
  MdPhoneIphone,
  MdDownload,
} from "react-icons/md";

const AppInstallPromo = ({ onClose }) => {
  const [isVisible, setIsVisible] = useState(true);

//   useEffect(() => {
//     // Check if already dismissed
//     const dismissed = localStorage.getItem("audioAppPromoDismissed");
//     if (!dismissed) {
//       setIsVisible(true);
//     }
//   }, []);

  const handleClose = (dismissPermanently = false) => {
    if (dismissPermanently) {
      localStorage.setItem("audioAppPromoDismissed", "true");
    }
    setIsVisible(false);
    onClose?.();
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-[60] bg-black bg-opacity-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full relative">
        {/* Close button */}
        <button
          onClick={() => handleClose(true)}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
        >
          <MdClose size={24} />
        </button>

        {/* Content */}
        <div className="p-6">
          <div className="flex items-center justify-center mb-4">
            <MdHeadphones className="text-black mr-2" size={32} />
            <h3 className="text-xl font-bold text-gray-800">
              Enhanced Audio Experience
            </h3>
          </div>

          <p className="text-gray-600 mb-4">
            For the best audio quality and additional features, we recommend
            using our app.
          </p>

          <div className="space-y-3 mb-6">
            {/* <div className="flex items-start">
              <MdPhoneIphone className="text-green-500 mt-1 mr-3 flex-shrink-0" size={20} />
              <span className="text-gray-700">Background playback support</span>
            </div> */}
            <div className="flex items-start">
              <MdPhoneIphone
                className="text-black mt-1 mr-3 flex-shrink-0"
                size={20}
              />
              <span className="text-gray-700">
                Higher quality audio streaming
              </span>
            </div>
            {/* <div className="flex items-start">
              <MdPhoneIphone className="text-green-500 mt-1 mr-3 flex-shrink-0" size={20} />
              <span className="text-gray-700">Offline listening capability</span>
            </div> */}
            <div className="flex items-start">
              <MdPhoneIphone
                className="text-black mt-1 mr-3 flex-shrink-0"
                size={20}
              />
              <span className="text-gray-700">Exclusive app-only features</span>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3">
            <div className="flex-1 relative">
              <a
              href="https://apps.apple.com/in/app/cruze/id6756572882"
              target="_blank"
              rel="noopener noreferrer"
              className="flex-1 flex items-center justify-center bg-[#0F9D58] text-white py-2 px-4 rounded-lg hover:bg-[#0b8043] transition-colors"
            >
                <MdDownload className="mr-2" />
                App Store
              </a>
              {/* <span className="absolute -top-2 -right-2 bg-yellow-500 text-white text-xs font-bold px-2 py-1 rounded-full">
                Coming Soon
              </span> */}
            </div>
            <a
              href="https://play.google.com/store/apps/details?id=com.cruze"
              target="_blank"
              rel="noopener noreferrer"
              className="flex-1 flex items-center justify-center bg-[#0F9D58] text-white py-2 px-4 rounded-lg hover:bg-[#0b8043] transition-colors"
            >
              <MdDownload className="mr-2" />
              Google Play
            </a>
          </div>

          <button
            onClick={() => handleClose(false)}
            className="mt-4 text-sm text-blue-500 hover:text-blue-700 w-full text-center"
          >
            Continue in browser
          </button>
        </div>
      </div>
    </div>
  );
};

export default AppInstallPromo;
